import { memo, MouseEvent, ReactNode } from 'react'
import cn from 'classnames'

import s from './ListRow.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  testId?: string
}

export const ListRow = memo(function ListRow({ children, className, onClick, testId }: IProps) {
  return (
    <div
      className={cn(s.ListRow, { [s.ListRow_clickable]: onClick }, className)}
      data-name="tableRow"
      data-test-id={testId}
      onClick={onClick}
    >
      {children}
    </div>
  )
})
